import * as PIXI from "pixi.js";
import {app, events, loader} from "../../utils/pixiApp";
import TWEEN from "@tweenjs/tween.js";
import {getTileDeviceMedia} from "../../utils/sizes";

export class Modal extends PIXI.Container {
    constructor() {
        super();

        this.ticker = PIXI.Ticker.shared;
        this.pivot.set(.5,.5)
        this._zIndex = 9000
        this.rect = undefined
        this.TWEEN = TWEEN;
        this.tweenBgAnimate = new this.TWEEN.Tween({alpha: 0}).to({alpha: 1}, 300).onUpdate((obj) => {
            this.rect.alpha = obj.alpha
        })
        events.onLoadApp(this.onLoadApp.bind(this))
        events.onScreenResizeEvent(() => {
            this.resizeView();
        })

        this.on('IS_OPEN_EVENT', this.onIsOpenEvent.bind(this))
        this.ticker.add(() => this.TWEEN.update())

    }

    resizeView() {
        this.setSize({width: app.screen.width, height: app.screen.height});
        if(this.rect && this.rect.clear) {
            this.rect.clear()
            this.rect.rect(0,0,app.screen.width, app.screen.height)
            this.rect.fill('rgba(0, 0, 0, .75)')
            if(this.rect.children.length > 0) {
                this.rect.children[0].position.set(this.rect.width / 2, this.rect.height / 2)
            }
        }
    }

    onOpen(component) {
        this.setContent(component)
        component.on('IS_OPEN_EVENT', this.onIsOpenEvent.bind(this))
    }

    onClose() {
        this.tweenCloseComponent = new this.TWEEN.Tween({scale: 1})
            .to({scale: 0}, 600)
            .easing(TWEEN.Easing.Elastic.In)
            .onUpdate(obj => {
                this.rect.children[0].scale.set(obj.scale)
            });
        this.tweenCloseBgAnimate = new this.TWEEN.Tween({alpha: 1}).to({alpha: 0}, 200)
            .onUpdate((obj) => {
            this.rect.alpha = obj.alpha
            })
            .onComplete(() => {
                this.removeContent()
                this.rect.scale.set(0)
            })

        this.tweenCloseComponent.chain(this.tweenCloseBgAnimate);

        this.tweenCloseComponent.start()
    }

    onEmitIsOpenEvent(isOpen, component) {
        this.emit('IS_OPEN_EVENT', isOpen, component)
    }

    onIsOpenEvent(isOpen, component) {
        if(isOpen && component) {
            this.onOpen(component)
        } else {
            this.onClose()
        }
    }

    removeContent() {
        if(this.rect.children) {
            this.rect.removeChildren(0)
        }
    }

    setContent(component) {
        const update = (obj) => {
            component.scale.set(obj.scale)
        }
        this.tweenComponent = new this.TWEEN.Tween({scale: 0})
            .to({scale: 1}, 600)
            .easing(TWEEN.Easing.Elastic.Out)
            .onUpdate(update);

        if(this.rect?.children) {
            this.removeContent();
        }

        this.rect.scale.set(1)
        component.scale.set(0)
        component.pivot.set(.5,.5)
        component.position.set(this.rect.width / 2, this.rect.height / 2)
        this.rect.addChild(component)
        this.addChild(this.rect)
        this.tweenBgAnimate.chain(this.tweenComponent);

        this.tweenBgAnimate.start();
    }

    onLoadApp() {
        this.position.set(0,0);
        this.setSize({width: app.screen.width, height: app.screen.height});
        this.rect = new PIXI.Graphics()
        this.rect.rect(0,0, app.screen.width, app.screen.height)
        this.rect.fill('rgba(0, 0, 0, .75)')

        this.rect.eventMode = 'static'
    }
}